import { authenticatedApiCall } from '@/api/authenticatedApiCall'

export const getInfo = async () => {
  const url = '/v6/info/'

  return await authenticatedApiCall({ url })
}
